import React, { Fragment, useEffect, useRef } from "react";
import { Label, UncontrolledTooltip } from "reactstrap";
//Import Flatepicker
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import FormInputError from "./FormInputError";
import { useLocation } from "react-router-dom";
import { generateDisabledDateForDP } from "utils";
const DatePickerInput = ({
  id,
  name,
  value,
  inputField,
  label: propLabel,
  inputClass: propInputClass,
  labelClass: propLabelClass,
  placeholder: propPlaceholder,
  onChange,
  customOnChange,
  onBlur,
  invalid,
  error,
  wrapperClassNames,
  disabledDates,
  disableFutureDates,
  disablePastDates,
  disableFutureDatesAndToday,
  disablePastDatesAndToday,
  removeDisable,
  removeIcon,
  noLabel,
  minDate,
  maxDate,
  readOnly,
  removeOnClose,
  notCloseOnSelect,
  clearIcon,
  inFilter,
  disableInvalidPreload,
}) => {
  const label =
    inputField && inputField.label_name ? inputField.label_name : propLabel;
  const placeholder =
    inputField && inputField.placeholder
      ? inputField.placeholder
      : propPlaceholder;
  const labelClass = `${
    inputField && inputField.label_class ? inputField.label_class : ""
  }${propLabelClass ? propLabelClass : ""}`;

  const inputClass = `${
    inputField && inputField.input_class ? inputField.input_class : ""
  }${propInputClass ? propInputClass : ""}`;

  const handleChange = (date, dateStr, instance) => {
    onChange(`${name}`, dateStr ? dateStr : "");

    // inputRef.current.flatpickr.altInput.blur()
  };

  const handleBlur = () => {
    onBlur(`${name}`, true);
  };

  const inputRef = useRef(null);

  useEffect(() => {
    if (invalid) {
      inputRef.current.flatpickr.altInput.classList.add("border-danger");
    } else {
      inputRef.current.flatpickr.altInput.classList.remove("border-danger");
    }

    if (inputClass) {
      inputRef.current.flatpickr.altInput.classList.add(inputClass);
    }
    if (readOnly) {
      inputRef.current.flatpickr.altInput.classList.add("bg-gray-600");
      inputRef.current.flatpickr.altInput.classList.add("bg-opacity-10");
    }
    if (!readOnly) {
      inputRef.current.flatpickr.altInput.classList.remove("bg-gray-600");
      inputRef.current.flatpickr.altInput.classList.remove("bg-opacity-10");
    }
  }, [invalid, inputClass, readOnly]);

  const location = useLocation();
  const { pathname } = location;
  // to know if the page link has a view word or not
  const pageType = pathname.split("/")[2];

  return (
    <div className={`${wrapperClassNames ? wrapperClassNames : ""}`}>
      {!noLabel ? (
        <Fragment>
          <Label
            htmlFor={id}
            className={`text-capitalize ${
              inputField?.is_required ? "required-label" : ""
            } ${labelClass ? labelClass : ""}`}
            // data-toggle="tooltip"
            // title={placeholder ? placeholder : ""}
            id={`tooltip-${id}`}
          >
            {label}
          </Label>
          {placeholder && (
            <UncontrolledTooltip placement="top" target={`tooltip-${id}`}>
              {placeholder}
            </UncontrolledTooltip>
          )}
        </Fragment>
      ) : null}
      <div className="position-relative overflow-hidden">
        <Flatpickr
          ref={inputRef}
          id={id}
          name={name}
          value={value}
          className={`form-control ${inFilter ? "filter-input" : ""} ${
            pageType === "view" ? "border-0" : ""
          }`}
          placeholder={placeholder ? placeholder : "YYYY-MM-DD"}
          options={{
            minDate: minDate ? minDate : null,
            maxDate: maxDate ? maxDate : null,
            altInput: true,
            allowInvalidPreload: disableInvalidPreload ? false : true,

            // altFormat: "Y-m-d",
            altFormat: "d-m-Y",
            dateFormat: "Y-m-d",
            // allowInput: true,
            // disable typing in view page
            allowInput: pageType !== "view" && !readOnly ? true : false,
            // disable on click in view page
            clickOpens: pageType !== "view" && !readOnly ? true : false,
            // closeOnSelect: notCloseOnSelect ? false : true,
            disable: removeDisable
              ? []
              : disabledDates
              ? disabledDates
              : [
                  function (date) {
                    return generateDisabledDateForDP(date, {
                      disableFutureDates,
                      disableFutureDatesAndToday,
                      disablePastDates,
                      disablePastDatesAndToday,
                    });
                  },
                ],
          }}
          // onClose={handleBlur}
          onBlur={handleBlur}
          onChange={customOnChange ? customOnChange : handleChange}
          onClose={
            !removeOnClose
              ? customOnChange
                ? customOnChange
                : handleChange
              : () => {
                  return;
                }
          }
        />
        {clearIcon && inputRef.current?.flatpickr?.input?.value ? (
          <div
            className="input-group-append"
            style={{
              position: "absolute",
              right: "0",
              top: "0",
              // zIndex: "100",
            }}
          >
            <button
              type="button"
              className="btn btn-outline-secondary px-1"
              style={{
                borderRight: "0",
                borderTop: "0",
                borderBottom: "0",
                borderRadius: "0",
              }}
              onClick={() => {
                if (!inputRef?.current?.flatpickr) return;
                inputRef.current.flatpickr.clear();
              }}
            >
              <i className="mdi mdi-close font-size-12" aria-hidden="true" />
            </button>
          </div>
        ) : null}
        {/* show right icon in all pages except the view page */}
        {pageType !== "view" && !readOnly && !removeIcon ? (
          <div
            className="input-group-append"
            style={{
              position: "absolute",
              right: "0",
              top: "0",
              height: "100%",
              // zIndex: "100",
            }}
          >
            <button
              type="button"
              className={`btn ${
                invalid ? "btn-outline-danger" : "btn-outline-gray-500"
              }`}
              style={{
                borderRight: "0",
                borderTop: "0",
                borderBottom: "0",
                borderRadius: "0",
                height: "100%",
              }}
              disabled
            >
              <i className="fa fa-calendar" aria-hidden="true" />
            </button>
          </div>
        ) : null}
      </div>
      {/* Error Message */}
      {invalid && pageType !== "view" && !readOnly ? (
        <FormInputError error={error} selectError={true} />
      ) : null}
    </div>
  );
};

export default DatePickerInput;
